<div class="col-lg-12" *ngIf="profileData?.sector">
    <div class="col-lg-12">
        <div class="property-details-box">
            <!--<h4 class="bluelabel margin-bottom-10">{{quote?.longName}}</h4>-->
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="form-group">

                        <h6 class="displayvalue">{{profileData?.address1}}</h6>
                        <h6 class="displayvalue">{{profileData?.city}}, {{profileData?.state}} {{profileData?.zip}}</h6>
                        <h6 class="displayvalue">{{profileData?.phone}}</h6>
                        <h6 class="displayvalue">Website :<a href="{{profileData?.website}}" class="a-link" target="_blank"> {{profileData?.website}}</a></h6>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <h6 class="displayvalue">Sector : {{profileData?.sector}}</h6>
                        <h6 class="displayvalue">Industry : {{profileData?.industry}}</h6>
                        <h6 class="displayvalue">Full Time Employees : {{profileData?.fullTimeEmployees | number:'1.0':'en-US'}}</h6>
                    </div>
                </div>
            </div>
            <h4>Key Executives</h4>
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="table-responsive">
                      <table class="table basictable row-border hover">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Title</th>
                            <th>Pay</th>
                            <th>Exercised</th>
                            <th>Year Born</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of profileData?.companyOfficers">
                            <td>{{item.name}}</td>
                            <td>{{item.title}}</td>
                            <td>{{item.totalPay?.fmt ? item.totalPay?.fmt : 'N/A'}}</td>
                            <td>{{item.exercisedValue?.fmt ? item.exercisedValue.fmt : 'N/A'}}</td>
                            <td>{{item.yearBorn ?item.yearBorn :'N/A'}}</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr *ngIf="profileData?.companyOfficers.length == 0 ">
                            <td colspan="5" class="odd no-data-available">
                              <div class="nodata">
                                <i class="fa fa-exclamation-triangle icon"></i>
                                <p>No Data Available</p>
                              </div>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                        </div>
                    </div>
                </div>
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <h4>Description</h4>
                    <p>{{profileData?.longBusinessSummary}}</p>
                </div>
            </div>
        </div>
            </div>

        </div>
